export default __webpack_public_path__ + "static/media/share-fb.290b6d67.svg";